import { render, staticRenderFns } from "./LargeCard.vue?vue&type=template&id=07ae616d&scoped=true"
import script from "./LargeCard.vue?vue&type=script&lang=js"
export * from "./LargeCard.vue?vue&type=script&lang=js"
import style0 from "./LargeCard.vue?vue&type=style&index=0&id=07ae616d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ae616d",
  null
  
)

export default component.exports